import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { EALL_TRACKS, Layout } from '../../interfaces/search-location.interface';

@Injectable({
  providedIn: 'root'
})
export class CircuitListService {
  public searchBoxFilterText = new BehaviorSubject<string | null>(null);
  public circuitOnlyWithLayoutsFilter = new BehaviorSubject<boolean | null>(null);
  public trackLayoutAction = new BehaviorSubject<TrackLayoutAction>(TrackLayoutAction.Edit);

  public _showTrackDetailsSubject$ = new BehaviorSubject<{show: boolean, layout: Layout}>({show: false, layout:<any>null});
  public _selectedTrackActiveSubject$ = new BehaviorSubject<boolean | null>(false);
  private _circuitTrackState: string = '';
  private _geofenceType: string = EALL_TRACKS.CIRCUIT;
  public _circuitState = new Subject<any>();
  public sharecircuitState = this._circuitState.asObservable();

  public set showTrackDetails(view: {show: boolean, layout: Layout, type?:string}) {
    this._showTrackDetailsSubject$.next(view);
  }
  
  public get showTrackDetails(): any {
    return this._showTrackDetailsSubject$.asObservable();
  }

  public set setSelectedTrackStatus(status:boolean) {
    this._selectedTrackActiveSubject$.next(status);
  }
  
  public get selectedTrackStatus(): any {
    return this._selectedTrackActiveSubject$.asObservable();
  }

  public set circuitTrackState(state: string) {
    this._circuitTrackState = state;
  }

  public get circuitTrackState(): string {
    return this._circuitTrackState;
  }

  public set geofenceType(type: string) {
    this._geofenceType = type;
  }

  public get geofenceType(): string {
    return this._geofenceType;
  }

  public sendCircuitState(value: any) { //Added to check whether offroad gpx uploaded or not 
    this._circuitState.next(value);
  }
}


export enum TrackLayoutAction {
  New,
  Edit,
  Update
}